"use client";
import Script from 'next/script'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { fbPixelId } from '@utils/constants'

const MetaPixel = () => {
	const router = useRouter()

	// Fire a PageView on client-side (SPA) route changes. The initial
	// PageView is sent by the base pixel snippet below.
	useEffect(() => {
		const handleRouteChange = () => {
			if (window.fbq) {
				window.fbq('track', 'PageView')
			}
		}
		router.events.on('routeChangeComplete', handleRouteChange)
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange)
		}
	}, [router.events])

	if (!fbPixelId) {
		return null
	}

	return (
		<Script id="meta-pixel" strategy="afterInteractive">
			{`
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${fbPixelId}');
				fbq('track', 'PageView');
			`}
		</Script>
	)
}

export default MetaPixel
